import axios from 'axios';

export default class CourseListHandler {
  constructor() {
    this.addEventHandlerAddToCartButtons();
    this.addEventHandlerIntakeChanged();
    this.addEventListenerToDeleteButtons();
    this.addEventHandlerToCourseListCards();
  }

  handleAddToCart(event) {
    const input = event.target;
    const courseId = input.dataset.course;
    const intakeId = input.dataset.intakeId;

    if(!intakeId) {
      return;
    }

    axios.post('/add-to-cart', {
        'courseId': courseId,
        'intakeId': intakeId
    })
    .then( response => {
      const cart = response.data.cart;
      const order = response.data.order;
      const grandTotal = response.data.grandTotal;
      const courseListCartContentsMessage = response.data.courseListCartContentsMessage;

      const courseListCartContentsSpan = document.querySelector('.contents__span');
      if(courseListCartContentsSpan) {
        courseListCartContentsSpan.innerHTML = courseListCartContentsMessage;
      }


      const cartElements = document.getElementsByClassName('cart-element');
      while(cartElements.length > 0){
        cartElements[0].parentNode.removeChild(cartElements[0]);
      }

      const deleteButtons = document.getElementsByClassName('delete-button');
      while(deleteButtons.length > 0){
        deleteButtons[0].parentNode.removeChild(deleteButtons[0]);
      }

      const separators = document.getElementsByClassName('separator-cart-element');
      while(separators.length > 0){
        separators[0].parentNode.removeChild(separators[0]);
      }

      const total = document.getElementsByClassName('cart-element-total');
      while(total.length > 0){
        total[0].parentNode.removeChild(total[0]);
      }

      const cartContainer = document.querySelector('[data-cart-elements]');

      for(let i=0; i < order.length; i++) {
        const information = cart[order[i]];

        const cartElement = document.createElement('div');
        cartElement.id = 'cart-course-' + order[i];
        cartElement.classList.add('cart-element');

        const courseInformation = document.createElement('div');
        courseInformation.classList.add('course-information');

        const spanLabel = document.createElement('span');
        spanLabel.classList.add('label');
        spanLabel.innerText = information.courseTitle;

        const span = document.createElement('span');
        span.innerText = information.intakeTitle;

        courseInformation.appendChild(spanLabel);
        courseInformation.appendChild(span);

        const price = document.createElement('div');
        price.classList.add('price');
        price.innerHTML = information.priceFormatted;

        const deleteButton = document.createElement('div');
        deleteButton.id = 'delete-button-course-' + order[i];
        deleteButton.classList.add('delete-button');
        deleteButton.dataset.course = order[i];
        deleteButton.innerHTML = 'Delete icon&nbsp;&nbsp;&nbsp; Delete';
        deleteButton.addEventListener('click', this.deleteElementFromCart);

        const hr = document.createElement('hr');
        hr.id = 'hr-course-' + order[i];
        hr.classList.add('separator-cart-element');

        cartElement.appendChild(courseInformation);
        cartElement.appendChild(price);

        cartContainer.appendChild(cartElement);
        cartContainer.appendChild(deleteButton);
        cartContainer.appendChild(hr);
      }

      const totalDiv = document.createElement('div');
      totalDiv.classList.add('cart-element-total');

      const divLabel = document.createElement('div');
      divLabel.classList.add('total-label');
      divLabel.innerHTML = 'Total:';

      totalDiv.appendChild(divLabel);
      
      const cartTotal = document.createElement('div');
      cartTotal.classList.add('cart-total');
      
      const cartTotalSpan = document.createElement('span');
      cartTotalSpan.classList.add('cart-total__span');

      if(Object.entries.length > 0) {
        cartTotalSpan.innerHTML = grandTotal;

        const taxesMessage = document.createElement('span');
        taxesMessage.id = 'taxes-message';
        taxesMessage.classList.add('taxes-included__span');
        taxesMessage.innerHTML = 'Vat. inc';

        cartTotal.append(cartTotalSpan);
        cartTotal.append(taxesMessage);

      }
      else {
        cartTotalSpan.innerHTML = 'Your cart is empty';
        cartTotal.append(cartTotalSpan);
      }

      totalDiv.appendChild(cartTotal);

      cartContainer.appendChild(totalDiv);

      const parentNode = input.parentNode;
      const button = document.createElement('button');
      button.id = 'delete-from-cart-' + courseId;
      button.innerHTML = 'Delete';
      button.classList.add('delete-button-list');
      button.classList.add('btn');
      button.dataset.course = courseId;
      button.addEventListener('click', this.deleteElementFromCart);

      parentNode.removeChild(input);
      parentNode.appendChild(button);
    })
    .catch( error => {
      if(error.response.status === 422) {
      }
    });
  }

  handleChangeIntake(event) {
    const input = event.target;
    const value = input.value;
    let inputId = input.id;

    inputId = inputId.split('-')[1];

    const addToCartButton = document.getElementById('add-to-cart-' + inputId);
    if(addToCartButton) {
      addToCartButton.dataset.intakeId = value;
    }
  }

  handleCardBehavior(event) {
    const card = event.target;

    if(!card) {
      return;
    }

    if(card.classList.contains('card-select')) {
      card.classList.remove('card-select');
      return;
    }

    let elements = document.getElementsByClassName('card-select');
    elements.forEach(element => {
      element.classList.remove('card-select');
    });

    card.closest('.four-cols__card').classList.toggle('card-select', !card.closest('.four-cols__card').classList.contains('card-select'));
  }

  addEventHandlerAddToCartButtons() {
    let elements = document.getElementsByClassName('add-to-cart');
    elements.forEach(element => {
        element.addEventListener('click', this.handleAddToCart.bind(this));
    });
  }

  addEventHandlerIntakeChanged() {
    let elements = document.getElementsByClassName('intake-selection');
    elements.forEach(element => {
      element.addEventListener('change', this.handleChangeIntake);
    })
  }

  addEventHandlerToCourseListCards() {
    let elements = document.getElementsByClassName('four-cols__card');
    elements.forEach(element => {
      element.addEventListener('click', this.handleCardBehavior);
    });
  }

  deleteElementFromCart(event) {
    const element = event.target;
    const courseID = element.dataset.course;

    axios.post('/remove-from-cart/'+courseID)
    .then( (response) => {
      console.log('Item deleted from cart!');

      const cart = response.data.cart;
      const order = response.data.order;
      const grandTotal = response.data.grandTotal;
      const courseListCartContentsMessage = response.data.courseListCartContentsMessage;

      const courseListCartContentsSpan = document.querySelector('.contents__span');
      if(courseListCartContentsSpan) {
        courseListCartContentsSpan.innerHTML = courseListCartContentsMessage;
      }

      const cartElements = document.getElementsByClassName('cart-element');
      while(cartElements && cartElements.length > 0){
        cartElements[0].parentNode.removeChild(cartElements[0]);
      }

      const deleteButtons = document.getElementsByClassName('delete-button');
      while(deleteButtons && deleteButtons.length > 0){
        deleteButtons[0].parentNode.removeChild(deleteButtons[0]);
      }

      const separators = document.getElementsByClassName('separator-cart-element');
      while(separators && separators.length > 0){
        separators[0].parentNode.removeChild(separators[0]);
      }

      const total = document.getElementsByClassName('cart-element-total');
      while(total && total.length > 0){
        total[0].parentNode.removeChild(total[0]);
      }

      const cartContainer = document.querySelector('[data-cart-elements]');

      for(let i=0; i < order.length; i++) {
        const information = cart[order[i]];

        const cartElement = document.createElement('div');
        cartElement.id = 'cart-course-' + order[i];
        cartElement.classList.add('cart-element');

        const courseInformation = document.createElement('div');
        courseInformation.classList.add('course-information');

        const spanLabel = document.createElement('span');
        spanLabel.classList.add('label');
        spanLabel.innerText = information.courseTitle;

        const span = document.createElement('span');
        span.innerText = information.intakeTitle;

        courseInformation.appendChild(spanLabel);
        courseInformation.appendChild(span);

        const price = document.createElement('div');
        price.classList.add('price');
        price.innerHTML = information.priceFormatted;

        const deleteButton = document.createElement('div');
        deleteButton.id = 'delete-button-course-' + order[i];
        deleteButton.classList.add('delete-button');
        deleteButton.dataset.course = order[i];
        deleteButton.innerHTML = 'Delete icon&nbsp;&nbsp;&nbsp; Delete';

        const hr = document.createElement('hr');
        hr.id = 'hr-course-' + order[i];
        hr.classList.add('separator-cart-element');

        cartElement.appendChild(courseInformation);
        cartElement.appendChild(price);

        cartContainer.appendChild(cartElement);
        cartContainer.appendChild(deleteButton);
        cartContainer.appendChild(hr);
      }

      const totalDiv = document.createElement('div');
      totalDiv.classList.add('cart-element-total');

      const divLabel = document.createElement('div');
      divLabel.classList.add('total-label');
      divLabel.innerHTML = 'Total:';

      totalDiv.appendChild(divLabel);
      
      const cartTotal = document.createElement('div');
      cartTotal.classList.add('cart-total');
      
      const cartTotalSpan = document.createElement('span');
      cartTotalSpan.classList.add('cart-total__span');

      if(Object.entries.length > 0) {
        cartTotalSpan.innerHTML = grandTotal;

        const taxesMessage = document.createElement('span');
        taxesMessage.id = 'taxes-message';
        taxesMessage.classList.add('taxes-included__span');
        taxesMessage.innerHTML = 'Vat. inc';

        cartTotal.append(cartTotalSpan);
        cartTotal.append(taxesMessage);

      }
      else {
        cartTotalSpan.innerHTML = 'Your cart is empty';
        cartTotal.append(cartTotalSpan);
      }

      totalDiv.appendChild(cartTotal);

      cartContainer.appendChild(totalDiv);

      element.id = 'add-to-cart-' + courseID;
      element.innerHTML = 'Add to Cart';
      element.classList.add('add-to-cart');
      element.classList.remove('delete-button-list');
      element.dataset.course = courseID;
      element.removeEventListener('click', this.deleteElementFromCart);
      element.addEventListener('click', this.handleAddToCart);
    })
    .catch(function(response) {
      console.log(response);
    })
  }

  addEventListenerToDeleteButtons() {
    const deleteButtons = document.getElementsByClassName('delete-button-list');

    deleteButtons.forEach(element => {
      element.addEventListener('click', this.deleteElementFromCart.bind(this));
    });
  }
}
